import React, { useState } from "react";
import styles from "./ReturnsAndRefunds.module.scss";
import { Container } from "reactstrap";
import DynamicCardRow from "../../../../components/AdminPortalComponents/DynamicCardRow/DynamicCardRow";
import DynamicSquaredFilterBar from "../../../../components/common/AdminCommonComponents/FilterBars/DynamicSquaredFilterBar/DynamicSquaredFilterBar";
import ShippingCarrierPerformance from "../../../../components/AdminPortalComponents/OrderManagement/OrderFulfillment/ShippingCarrierPerformance/ShippingCarrierPerformance";
import ReturnTracking from "../../../../components/AdminPortalComponents/OrderManagement/ReturnsRefunds/ReturnTracking/ReturnTracking";
import ReturnOrderDetail from "../../../../components/AdminPortalComponents/OrderManagement/ReturnsRefunds/ReturnOrderDetail/ReturnOrderDetail";
import RefundTracking from "../../../../components/AdminPortalComponents/OrderManagement/ReturnsRefunds/RefundTracking/RefundTracking";
import RefundDetail from "../../../../components/AdminPortalComponents/OrderManagement/ReturnsRefunds/RefundDetail/RefundDetail";

const orderFulfillmentData = [
    { title: "Total Return Requests", value: 0 },
    { title: "Sellers pending approval", value: 0 },
    { title: "Admin processing", value: 0 },
    { title: "Completed returns", value: 0 }
].map(item => ({
    ...item,
    title: item.title.toUpperCase()
}));

const tabsData = [
    { key: "1", label: "Return Tracking" },
    { key: "2", label: "Refund Tracking" },
];

const ReturnsAndRefunds = () => {
    const [activeTab, setActiveTab] = useState(tabsData[0]?.key || "");
    const [showReturnDetails, setShowReturnDetails] = useState(false);

    return (
        <div className={styles.mainContainer}>
            <Container fluid className={styles.orderWrapper}>
                <h5 className={styles.mainHeading}>Returns and Refunds</h5>
                <div className={styles.cardRowWrapper}>
                    <DynamicCardRow cards={orderFulfillmentData} />
                </div>
            </Container>

            {!showReturnDetails ? (
                <Container fluid className={styles.filterTableWrapper}>
                    <div className={styles.squareFilterBarWrapper}>
                        <DynamicSquaredFilterBar
                            tabs={tabsData}
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                            barType="default"
                        />
                    </div>

                    {activeTab === "1" && <ReturnTracking setShowReturnDetails={setShowReturnDetails} />}
                    {activeTab === "2" && <RefundTracking setShowReturnDetails={setShowReturnDetails} />}
                </Container>
            ) : (
                activeTab === "1" ? <ReturnOrderDetail setShowReturnDetails={setShowReturnDetails} /> : <RefundDetail setShowReturnDetails={setShowReturnDetails} />
            )}
        </div>
    );
};

export default ReturnsAndRefunds;